const cardsData = [
  {
    title: '热血动作片专场',
    desc: '精选高分动作片，从港式武打经典到好莱坞超级制作，每一部都让人热血沸腾',
    tag: '热门专题',
    img: 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20scene%20with%20dramatic%20explosions%20and%20heroic%20stance%2C%20warm%20golden%20lighting%2C%20cinematic%20photography%2C%20dark%20urban%20environment%2C%20professional%20color%20grading%2C%20high%20contrast%20dramatic%20mood%2C%20clean%20background&width=600&height=400&seq=wukong-cards-01&orientation=landscape'
  },
  {
    title: '喜剧片欢乐合集',
    desc: '解压必备，多部高分喜剧让你笑到停不下来，周末放松的最佳选择',
    tag: '编辑推荐',
    img: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20film%20aesthetic%20with%20colorful%20decor%2C%20warm%20lighting%2C%20happy%20and%20fun%20atmosphere%2C%20cinematic%20photography%20style%2C%20soft%20shadows%2C%20professional%20color%20grading%2C%20clean%20minimalist%20composition&width=600&height=400&seq=wukong-cards-02&orientation=landscape'
  },
  {
    title: '硬核科幻视觉盛宴',
    desc: '视觉震撼的科幻巨制，浩瀚宇宙与未来科技，带来极致的观影沉浸感',
    tag: '高分推荐',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20scene%20with%20nebulae%20and%20distant%20planets%2C%20dramatic%20cinematic%20lighting%2C%20cool%20blue%20and%20warm%20amber%20contrast%2C%20epic%20scale%2C%20professional%20visual%20effects%20aesthetic%2C%20clean%20composition%2C%20minimalist%20design&width=600&height=400&seq=wukong-cards-03&orientation=landscape'
  },
  {
    title: '悬疑推理精选',
    desc: '烧脑反转的悬疑佳片，层层递进的推理快感，考验你的智力和观察力',
    tag: '悬疑迷必看',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20room%20with%20warm%20lamp%20light%2C%20shadows%20and%20silhouettes%2C%20detective%20atmosphere%2C%20vintage%20decor%2C%20film%20noir%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20photography%2C%20rich%20amber%20tones%2C%20clean%20composition&width=600&height=400&seq=wukong-cards-04&orientation=landscape'
  },
  {
    title: '爱情片暖心推荐',
    desc: '温暖治愈的爱情故事，从青涩初恋到成熟情感，每部都能触动心弦',
    tag: '温情佳作',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20sunset%20scene%20with%20warm%20golden%20light%2C%20soft%20focus%20cinematic%20photography%2C%20dreamy%20atmosphere%2C%20elegant%20composition%2C%20professional%20color%20grading%2C%20warm%20tones%2C%20minimalist%20and%20clean%20background&width=600&height=400&seq=wukong-cards-05&orientation=landscape'
  },
  {
    title: '国产经典回顾',
    desc: '华语电影的经典之作，从文艺佳片到商业标杆，感受华语电影的魅力',
    tag: '经典必看',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20cinema%20aesthetic%20with%20warm%20red%20and%20gold%20tones%2C%20traditional%20and%20modern%20elements%20blend%2C%20dramatic%20lighting%2C%20professional%20photography%2C%20rich%20contrast%2C%20cultural%20atmosphere%2C%20clean%20minimalist%20composition&width=600&height=400&seq=wukong-cards-06&orientation=landscape'
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-layout-grid-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            热门推荐
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          悟空影视精选专题，总有一款适合你
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.map((card, idx) => (
            <div
              key={idx}
              className="rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-[10px] font-semibold rounded bg-accent-500/85 text-white whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors mb-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}